import type { UnknownAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { coreActions } from '../core-actions';
import * as actions from './postponedActionsActions';
import {
  getPostponableActionAttemptsLeft,
  mkPostponedAction,
  mkPostponedActionsStore,
  type PostponedActionsStore,
  setPostponableActionAttemptsLeft,
} from './postponedActionsTypes';

export const reducer = (
  state: PostponedActionsStore = mkPostponedActionsStore(),
  action: UnknownAction,
): PostponedActionsStore => {
  if (coreActions.sanitize.match(action)) {
    return state.delete('postponedActions');
  }

  if (actions.addPostponedAction.match(action)) {
    const { payload } = action;
    const { action: postponedAction } = payload;
    if (
      assert(postponedAction, 'addPostponedAction: action required') &&
      payload.maxAttempts &&
      getPostponableActionAttemptsLeft(postponedAction) === undefined
    ) {
      setPostponableActionAttemptsLeft(postponedAction, payload.maxAttempts);
    }
    return state.merge({
      postponedActions: state.postponedActions.push(
        mkPostponedAction({
          action: postponedAction,
          error: payload.error,
          onFailure: payload.onFailure,
          maxAttempts: payload.maxAttempts,
          key: uuidv4(),
        }),
      ),
    });
  }

  if (actions.dispatchPostponedActions.match(action)) {
    const postponedActions = action.payload;
    assert(postponedActions, 'dispatchPostponedActions: postponedActions required');
    return state.merge({
      postponedActions: state.postponedActions.filterNot((postponedAction) =>
        postponedActions.includes(postponedAction),
      ),
    });
  }

  if (actions.dismissPostponedActions.match(action)) {
    const postponedActions = action.payload;
    assert(postponedActions, 'dismissPostponedActions: postponedActions required');
    return state.merge({
      postponedActions: state.postponedActions.filterNot((postponedAction) =>
        postponedActions.includes(postponedAction),
      ),
    });
  }

  return state;
};

export default reducer;
